import { IClientControlOption } from '@/Interfaces/ControlOption.interface';
import { IParsedWhitelabelWithRelations } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import ClientsSelect from '../../../Components/ClientsSelect';
import OrganizationSelect from '../OrganizationSelect';
import AdditionalControlsInputLabel from './AdditionalControlsInputLabel';

interface IProps {
  clients: IClientControlOption[];
  whitelabels: IParsedWhitelabelWithRelations[];
  shouldUnregister?: boolean;
  showWhitelabelControl?: boolean;
  clientsDisabled?: boolean;
}

const AdditionalClientControls = ({ clients, whitelabels, shouldUnregister, showWhitelabelControl }: IProps) => {
  const { control } = useFormContext();

  return (
    <>
      <hr className='-mx-[32px] mt-8 mb-4' />
      {showWhitelabelControl ? (
        <div className='mb-3'>
          <AdditionalControlsInputLabel htmlFor='whitelabel-select' id='client-whitelabel-select-label'>
            Select Whitelabel
          </AdditionalControlsInputLabel>
          <OrganizationSelect
            control={control}
            options={whitelabels}
            shouldUnregister={shouldUnregister}
            name='whitelabel'
            id='whitelabel-select'
            placeholder='Select Whitelabel'
          />
        </div>
      ) : null}
      <div className='mb-3'>
        <AdditionalControlsInputLabel id='clients-select-label'>Select Client</AdditionalControlsInputLabel>
        <div className='text-[#777E90] text-[12px] mb-3'>You can select multiple Clients to assign this user</div>
        <Controller
          name='clients'
          defaultValue={[]}
          rules={{
            required: {
              value: true,
              message: 'Please select at least 1 client.',
            },
          }}
          control={control}
          shouldUnregister={shouldUnregister}
          render={({ field, fieldState: { error } }) => (
            <ClientsSelect
              {...field}
              // @ts-expect-error unknown prop
              labelId='clients-select-label'
              error={!!error}
              helperText={error?.message}
              options={clients}
            />
          )}
        />
      </div>
    </>
  );
};

AdditionalClientControls.propTypes = {
  clients: PropTypes.array,
  whitelabels: PropTypes.array,
  shouldUnregister: PropTypes.bool,
  showWhitelabelControl: PropTypes.bool,
};

export default AdditionalClientControls;
